// Cores das telas de disparo como variáveis CSS, tiradas do tema do painel —
// o mesmo disparo.css serve ao tema claro, ao escuro e ao Conversacional.
// Quem desenha põe `style={tokensDoDisparo(theme)}` no elemento de fora.
export function tokensDoDisparo(theme) {
  const p = theme.palette
  const escuro = p.mode === 'dark'
  const extras = theme.previewTokens || {}
  return {
    '--dp-bg': p.background.default,
    '--dp-surface': p.background.paper,
    '--dp-raised': extras.surfaceHover || (escuro ? 'rgba(255,255,255,0.06)' : 'rgba(15,23,18,0.05)'),
    '--dp-line': p.divider,
    '--dp-line-strong': extras.borderStrong || (escuro ? 'rgba(255,255,255,0.14)' : 'rgba(15,23,18,0.16)'),
    '--dp-fg': p.text.primary,
    '--dp-muted': p.text.secondary,
    '--dp-faint': p.text.disabled,
    '--dp-accent': p.primary.main,
    // No verde claro do tema escuro, texto branco some; o verde-escuro lê bem.
    '--dp-on-accent': escuro && theme.isPreview ? '#062b14' : p.primary.contrastText,
    '--dp-warn': p.warning.main,
    '--dp-danger': p.error.main,
    '--dp-info': p.info.main
  }
}
